import { render, staticRenderFns } from "./GenderList.vue?vue&type=template&id=663f679c"
import script from "./GenderList.vue?vue&type=script&lang=js"
export * from "./GenderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports